import { cn } from '@/lib/cn'
import { typoNode } from '@/lib/typo'

/**
 * A section inside a page (design §3.2, WP-06): `title-2` Onest semibold, an optional line of
 * explanation in caption ink-3, actions on the right. `as="h3"` inside a card or a drawer that
 * already sits under an `<h2>`.
 */
export function SectionHeader({
  title,
  description,
  actions,
  as: Tag = 'h2',
  tone = 'primary',
  id,
  className,
}: {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  as?: 'h2' | 'h3'
  /** `secondary`: a quieter group title (ink-2), e.g. «AI-провайдеры» above provider cards */
  tone?: 'primary' | 'secondary'
  id?: string
  className?: string
}) {
  return (
    <div className={cn('mb-3 flex flex-wrap items-end justify-between gap-x-4 gap-y-2', className)}>
      <div className="min-w-0">
        <Tag
          id={id}
          className={cn(
            'text-title-2 font-semibold [overflow-wrap:anywhere]',
            tone === 'secondary' ? 'text-ink-2' : 'text-ink-1',
          )}
        >
          {typoNode(title)}
        </Tag>
        {description && <p className="mt-1 max-w-prose text-caption text-ink-3">{typoNode(description)}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
